export default __webpack_public_path__ + "38ac10143bf985cdfb2c3159baa70835.png";